import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import { IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import { getUser } from 'common/selectors/user'
import AlertFormProvider, {
  useAlertForm
} from 'common/components/ParameterAlertForm/AlertFormProvider'
import Parameters from 'common/components/ParameterAlertForm/steps/Parameters/Parameters'
import Values from 'common/components/ParameterAlertForm/steps/Values/Values'
import Devices from 'common/components/ParameterAlertForm/steps/Devices/Devices'
import Settings from 'common/components/ParameterAlertForm/steps/Settings/Settings'
import styles from 'common/components/ParameterAlertForm/ParameterAlertForm.module.scss'

// Show only the current step. Settings stays mounted so its values are not lost.
const ActiveStep = ({ step, children }) => {
  const {
    state: { activeTab }
  } = useAlertForm()
  return activeTab === step ? children : null
}

// Builds the modal and passes its data to the shared form.
const AddParameterAlertModalForm = props => {
  const {
    onSubmit,
    user,
    translate,
    systems,
    systemsByGroup,
    parameterAlarmParamsBySystem,
    isSubmitting,
    isAddingEmail,
    submitError,
    addAlertRecipient,
    onDeleteAlertRecipient,
    projectId,
    projects
  } = props

  return (
    <div className={styles.modalContainer}>
      <IconButton
        className={styles.closeModalButton}
        onClick={props.hideModal}
        aria-label='close'
      >
        <CloseIcon />
      </IconButton>
      <Typography className={styles.header}>
        {translate('alertsPage.paramertersNewAlerts')}
      </Typography>

      <div className={styles.modal}>
        <AlertFormProvider
          formMode='add'
          onSubmit={onSubmit}
          modalActions={{
            addAlertRecipient,
            onDeleteAlertRecipient,
            hideModal: props.hideModal
          }}
          config={{
            translate,
            user,
            systems,
            systemsByGroup,
            parameterAlarmParamsBySystem,
            isSubmitting,
            isAddingEmail,
            submitError,
            projectId,
            projects
          }}
        >
          <form
            noValidate
            onKeyDown={ev => {
              if (ev.key === 'Enter') ev.preventDefault()
            }}
          >
            <ActiveStep step={0}>
              <Parameters />
            </ActiveStep>
            <ActiveStep step={1}>
              <Values />
            </ActiveStep>
            <ActiveStep step={2}>
              <Devices />
            </ActiveStep>
            <Settings />
          </form>
        </AlertFormProvider>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  user: getUser(state)
})

export default withLocalize(connect(mapStateToProps)(AddParameterAlertModalForm))
